import { Modal } from 'antd';
import {
  IconInfo,
  IconSuccessFilled,
  IconBugFilled,
} from '../components/icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { CHANGELOG } from '../../core/constants';
import { IconTile } from '../components/primitives';
import './layout.css';

const ChangelogModal = ({ open, onClose, isMobile }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={
        <div className="lms-changelog__head">
          <IconTile icon={<IconInfo />} tone="info" size="sm" />
          <span>{t('version.title')}</span>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={isMobile ? '95%' : 560}
    >
      <div className="lms-changelog">
        {CHANGELOG.map((entry, index) => (
          <div className="lms-changelog__release" key={entry.version}>
            <div className="lms-changelog__release-head">
              <span className="lms-figure lms-changelog__version">v{entry.version}</span>
              <span className="lms-figure lms-changelog__date">{entry.date}</span>
              {index === 0 && (
                <span className="lms-changelog__active">{t('common.active')}</span>
              )}
            </div>

            {entry.features.length > 0 && (
              <div className="lms-changelog__group">
                <div className="lms-changelog__group-label lms-changelog__group-label--feature">
                  <IconSuccessFilled />
                  {t('version.newFeatures')}
                </div>
                <ul className="lms-changelog__list">
                  {entry.features.map((f, i) => (
                    <li key={i}>{t(f)}</li>
                  ))}
                </ul>
              </div>
            )}

            {entry.bugFixes.length > 0 && (
              <div className="lms-changelog__group">
                <div className="lms-changelog__group-label lms-changelog__group-label--fix">
                  <IconBugFilled />
                  {t('version.bugFixes')}
                </div>
                <ul className="lms-changelog__list">
                  {entry.bugFixes.map((f, i) => (
                    <li key={i}>{t(f)}</li>
                  ))}
                </ul>
              </div>
            )}

            {index < CHANGELOG.length - 1 && <div className="lms-changelog__rule" />}
          </div>
        ))}
      </div>
    </Modal>
  );
};

ChangelogModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  isMobile: PropTypes.bool,
};

export default ChangelogModal;
